module.exports = __webpack_public_path__ + "img/x-viewer-mini.bae40aa6.svg";